import { LogoutOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../app/hooks';
import { clearSession } from '../../../app/store/clearSession';
import { useGetLatestReleaseNoteQuery } from '../../../services/releaseNotesApi';
import { LogoPmis } from '../../../assets/logoPmis/logoPmis';
import { useSectionAccess } from '../../../hooks';
import { SideNavbarItensType } from '../../../types';
import {
  ButtonLogout,
  LogoWrapper,
  MenuItem,
  Sider,
  StyledMenu,
  StyledSubMenu,
  VersionLabel,
} from './styles';

type SideNavbarProps = {
  navbarItens: SideNavbarItensType[];
};

export function SideNavbar(props: SideNavbarProps) {
  const { navbarItens } = props;
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();

  // para selecionar a opção certa do menu ao dar refresh na pagina
  const selectedPage = window.location.pathname;
  const firstPage = selectedPage.split('/')[1];
  const dispatch = useAppDispatch();
  const { canAccessPath } = useSectionAccess();

  const { data: latestReleaseNote } = useGetLatestReleaseNoteQuery();
  const displayedVersion = latestReleaseNote?.version
    ? `v${latestReleaseNote.version.replace(/^v/i, '')}`
    : '';

  async function handleLogout() {
    dispatch(clearSession());
    navigate('/login');
  }

  // A leaf is shown when the user can reach its section; a parent is shown when
  // any of its sub-items is.
  type MenuNode = { key: string; subItens?: { key: string }[] };
  function hasAccess(item: MenuNode): boolean {
    if (item.subItens?.length) {
      return item.subItens.some(hasAccess);
    }
    return canAccessPath(item.key);
  }
  return (
    <Sider
      theme="light"
      width={250}
      trigger={null}
      collapsible
      collapsed={collapsed}
      onMouseEnter={() => setCollapsed(false)}
      onMouseLeave={() => setCollapsed(true)}
    >
      <LogoWrapper collapsed={collapsed}>
        <LogoPmis />
      </LogoWrapper>
      <div
        style={{
          overflowY: 'auto',
          overflowX: 'hidden',
          height: '100%',
          marginTop: '15px',
        }}
      >
        <StyledMenu
          theme="light"
          defaultSelectedKeys={[selectedPage]}
          defaultOpenKeys={[firstPage]}
          mode="inline"
          style={{
            border: '0px',
          }}
        >
          {navbarItens.map((item) => {
            if (hasAccess(item)) {
              return item.subItens ? (
                <StyledSubMenu
                  key={item.key}
                  title={item.title}
                  icon={
                    <div>
                      <item.icon />
                    </div>
                  }
                >
                  {item.subItens.map((subItem) => {
                    return hasAccess(subItem) ? (
                      <Menu.Item key={subItem.key}>
                        <Link to={subItem.key}>{subItem.title}</Link>
                      </Menu.Item>
                    ) : null;
                  })}
                </StyledSubMenu>
              ) : (
                <MenuItem
                  key={item.key}
                  icon={
                    <div>
                      <item.icon />
                    </div>
                  }
                >
                  <Link to={item.key}>{item.title}</Link>
                </MenuItem>
              );
            }
            return null;
          })}
        </StyledMenu>
      </div>
      {displayedVersion && <VersionLabel>{displayedVersion}</VersionLabel>}
      <div>
        <ButtonLogout
          style={{
            width: collapsed ? '60px' : '90%',
            backgroundColor: collapsed
              ? 'var(--neutral_lightest)'
              : 'var(--brand-deep-green)',
          }}
          onClick={handleLogout}
          icon={
            <LogoutOutlined
              rotate={180}
              style={{ color: collapsed ? '#000' : 'var(--neutral_lightest)' }}
            />
          }
        >
          {!collapsed && 'Deslogar'}
        </ButtonLogout>
      </div>
    </Sider>
  );
}
